const storage = {
    getItem: key => localStorage.getItem(key),
    setItem: (key, value) => localStorage.setItem(key, value),
    removeItem: key => localStorage.removeItem(key),
};
var LocalStorageKeys;
(function (LocalStorageKeys) {
    LocalStorageKeys["LastOtoInsightsViewDate"] = "lastOtoInsightsViewDate";
})(LocalStorageKeys || (LocalStorageKeys = {}));
function getTodayFormatted() {
    const today = new Date();
    return today.toISOString().split('T')[0];
}
function getLastViewDate() {
    return storage.getItem(LocalStorageKeys.LastOtoInsightsViewDate);
}
function setLastViewDate(date) {
    storage.setItem(LocalStorageKeys.LastOtoInsightsViewDate, date);
}
export const storageData = {
    getLastViewDate,
    setLastViewDate,
    getTodayFormatted,
};
